import type React from 'react';
import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import type { TabsProps } from 'antd';
import 'styles/ant-design.css';
import { constructSubmissionDetailPath } from 'constants/path';
import { useTranslation } from 'react-i18next';
import { getSubmissionConfigTabs } from './submission-config-tabs';
import { useCallback, useMemo } from 'react';
import {
  BusinessLineResponseDtoNameEnum,
  SubmissionResponseDtoStatusEnum,
} from 'libs/pinnacle-sdk';

interface NavigationTabsProps {
  submissionId?: string;
  submissionStatus?: SubmissionResponseDtoStatusEnum;
  businessLine?: BusinessLineResponseDtoNameEnum;
  tabId?: string;
  isReadyForReview?: boolean;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  submissionId,
  submissionStatus,
  businessLine,
  isReadyForReview = false,
  tabId,
}) => {
  const { t } = useTranslation();
  const configTabs = getSubmissionConfigTabs(
    submissionStatus,
    businessLine,
    isReadyForReview,
    t
  );
  const navigate = useNavigate();

  const onChange = useCallback(
    (key: string) => {
      navigate(constructSubmissionDetailPath(submissionId || '', key));
    },
    [navigate, submissionId]
  );

  const items: TabsProps['items'] = useMemo(
    () =>
      configTabs
        .filter((item) => !item.hide)
        .map((tab) => ({
          key: tab.id.toString(),
          label: tab.tab,
          disabled: tab.disabled,
        })),
    [configTabs]
  );

  return (
    <div className="bg-[#E3F2FB] p-1 rounded-lg">
      <Tabs
        activeKey={tabId || '0'}
        onChange={onChange}
        items={items}
        className="custom-tabs"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
        animated={false}
      />
    </div>
  );
};

export default NavigationTabs;
